import React, {FC, useCallback} from 'react';

import {MessageModel} from '../../../../libs/shared/core/src/models/api/messageModel';
import {NewPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {MessageContext} from '../../../applications/bridge/v2/types/bridgeTypesV2';
import {LegacyMessageMoreDropdownEntryPointModel} from '../../../models/api/legacyEntryPointModel';
import {buildPublicId} from '../../../models/applications/publicIdTypes';
import {fetchApplicationPathAction} from '../../../store/data/applications/applicationsActions';
import {buildBaseContext, LegacyContextBuilder} from './legacyApplicationContextBase';
import {LegacyApplicationContextHostContainer} from './legacyApplicationContextHostContainer';

/*
 * Props.
 */

interface LegacyMessageApplicationContextHostProps {
  panelId: NewPanelId;
  entryPoint: LegacyMessageMoreDropdownEntryPointModel;
  message: MessageModel;
}

/*
 * Component.
 */

export const LegacyMessageApplicationContextHost: FC<LegacyMessageApplicationContextHostProps> = (props) => {
  const {panelId, entryPoint, message} = props;
  const messagePublicId = buildPublicId('message', message.id);

  const contextBuilder: LegacyContextBuilder = useCallback(
    (parameters): MessageContext => {
      const baseContext = buildBaseContext(parameters);
      const {dispatch} = parameters;

      const messageContext: MessageContext = {
        ...baseContext,
        type: 'message',
        messageId: messagePublicId,

        fetchPath: async () => dispatch(fetchApplicationPathAction(panelId)),
      };
      return messageContext;
    },
    [messagePublicId],
  );

  return (
    <LegacyApplicationContextHostContainer
      panelId={panelId}
      entryPoint={entryPoint}
      contextBuilder={contextBuilder}
    />
  );
};
